import useGetEditors from './useGetEditors'

export default useGetEditors
